import React from 'react';

import CollageDesigner from '../../../components/global/CollageDesigner';

const CollageDesignerView = () => {
  return <CollageDesigner />;
};

export default CollageDesignerView;
